import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import { FormLegend } from "folksam-ui";
import themeOverride from "./themeOverride";
import { ThemeProvider } from "react-jss";

const style = ({ theme }) => ({
  root: {
    marginBottom: theme.padding.sm,
    borderBottom: `1px solid ${theme.colors.tertiary4}`
  }
});

/**
 * Override of the TitleField component. Uses the legend for semantic purposes but dont show it as it is impossible to style :)
 * Based on https://github.com/mozilla-services/react-jsonschema-form/blob/v1.2.0/src/components/fields/TitleField.js
 */
const TitleField = ({ classes, title, required }) => (
  <ThemeProvider theme={{ theme: themeOverride }}>
    <div className={classes.root}>
      <FormLegend large required={required}>
        {title}
      </FormLegend>
    </div>
  </ThemeProvider>
);

TitleField.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  required: PropTypes.bool,
  classes: PropTypes.object
};

export default injectSheet(style)(TitleField);
